import React, { useEffect } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import Header from "../../components/ui/Header2";
import FloatingConsultationButton from "../../components/ui/FloatingConsultationButton";
import TrustBadgeStrip from "../../components/ui/TrustBadgeStrip";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import BenefitsSection from "./components/BenefitsSection";
import ProductCategoriesSection from "./components/ProductCategoriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ConsultationBookingSection from "./components/ConsultationBookingSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import ContactSection from "./components/ContactSection";
import { useDispatch } from "react-redux";
import {
  getAdvertismentService,
  getAllProductsService,
  getCategoriesService,
  getMyCartService,
  getStoreInfoService,
} from "redux/services/general_service";
import CategoryGrid from "./components/CategoryGrid";

const ArabicPharmacyEcommerceLandingPage = () => {
  const { isRTL, currentLanguage } = useLanguage();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoriesService({ page: 1 }));
    dispatch(getStoreInfoService());
    dispatch(getMyCartService());
    dispatch(getAdvertismentService({ page: 1 }));
    dispatch(getAllProductsService({ page: 1 }));
  }, []);

  return (
    <div
      className={`min-h-screen bg-background text-text-primary ${
        isRTL ? "font-cairo" : "font-sans"
      }`}
      dir={isRTL ? "rtl" : "ltr"}
      lang={currentLanguage}
    >
      {/* Header */}
      <Header />

      {/* Trust Badge Strip 
      <TrustBadgeStrip />*/}

      {/* Main Content Sections */}
      <main>
        {/* Hero Section - Above the fold with bilingual headline and CTAs */}
        {/*  <HeroSection />*/}

        {/* Problem Agitation - Healthcare accessibility challenges */}
    

        {/* Solution Overview - Interactive product categories */}
        <SolutionSection />

        {/* Benefits Grid - 5 key value propositions */}
        <BenefitsSection />

        <CategoryGrid />

        {/* Product Categories Showcase - Filterable grid with bilingual search 
        <ProductCategoriesSection />*/}

            <ProblemSection />

        {/* Testimonials Carousel - Video testimonials with bilingual subtitles 
        <TestimonialsSection />*/}

        {/* Pharmaceutical Consultation Booking - Calendar widget and symptom checker 
        <ConsultationBookingSection />
        
        {/* FAQ Accordion - Safety concerns and delivery reliability 
        <FAQSection /> */}

        {/* Final CTA - Same-day delivery promise with countdown
        <FinalCTASection />
        
        {/* Contact Form - Bilingual support with address completion 
        <ContactSection />*/}
      </main>

      {/* Floating Consultation Button */}
      <FloatingConsultationButton />
    </div>
  );
};

export default ArabicPharmacyEcommerceLandingPage;
